module.exports = __webpack_public_path__ + "static/media/motor chart 2.e4708a25.png";